import confetti from 'canvas-confetti';

export function fireSideCannons() {
  const end = Date.now() + 500;
  const colors = ['#ff3355', '#ffaa00', '#ffdd00', '#44cc44', '#3399ff', '#aa44ff'];
  let colorIndex = 0;
  const frame = () => {
    if (Date.now() > end) return;
    const frameColors = [colors[colorIndex % colors.length]];
    colorIndex++;
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      startVelocity: 60,
      origin: { x: 0, y: 0.5 },
      colors: frameColors,
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      startVelocity: 60,
      origin: { x: 1, y: 0.5 },
      colors: frameColors,
    });
    requestAnimationFrame(frame);
  };
  frame();
}
